import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "./CollaboratorsSection.css";

const token = localStorage.getItem("token");

const CollaboratorsSection = () => {
  const [collaborators, setCollaborators] = useState([]);
  const navigate = useNavigate();
  const scrollRef = useRef(null);
const handleScroll = (dir) => {
    scrollRef.current.scrollBy({
      left: dir === "right" ? 300 : -300,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    fetchCollaborators();
  }, []);

  const fetchCollaborators = async () => {
    try {
      const res = await axios.get("/collaborator", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const nonDeleted = res.data.filter((c) => c.deletedAt === null);
      setCollaborators(nonDeleted);
    } catch (error) {
      console.error("Erreur lors du chargement des collaborateurs", error);
    }
  };

  const scrollRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: 220, behavior: "smooth" });
    }
  };

  const scrollLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({ left: -220, behavior: "smooth" });
    }
  };

  return (
    <section className="collaborators-section">
      <h2 className="title">Nos Collaborateurs</h2>
      <p className="subtitle">
        Plus de 30 juniors entrepreneurs collaborent sur nos projets
      </p>

      <div className="collaborators-wrapper">
        {/* Flèche gauche */}
       <button className="arrow-btn left" onClick={() => handleScroll("left")}>
                         <FontAwesomeIcon icon={faChevronLeft} />
                       </button>

        {/* Liste des collaborateurs */}
        <div className="collaborators-grid" ref={scrollRef}>
          {collaborators.map((collab) => (
            <div key={collab.id} className="collaborator-card">
              <img
                src={`/${collab.photoUrl}`}
                alt={collab.name}
                className="collaborator-photo"
              />
              <p className="collaborator-name">{collab.name}</p>
              <p className="collaborator-job">
                {collab.jobTitle} - {collab.positionJEI}
              </p>
              <a href={`mailto:${collab.email}`} className="collaborator-email">
                {collab.email}
              </a>
            </div>
          ))}
        </div>

        {/* Flèche droite */}
        <button className="arrow-btn right" onClick={() => handleScroll("right")}>
                            <FontAwesomeIcon icon={faChevronRight} />
                          </button>
      </div>

      <div className="manage-button-container">
        <button
          onClick={() => navigate("/admin/collaborators")}
          className="manage-button"
        >
          Gérer les collaborateurs
        </button>
      </div>
    </section>
  );
};

export default CollaboratorsSection;
